

export class FieldModel extends kendo.data.ObservableObject {
    constructor() {
        super(); 
        this.set('Value', 0); 
        this.set('Label', null); 
        this.set('Group', null); 
        this.set('GroupId', null);        
    }
     
    public Value: number; 
    public Label: string; 
    public Group: string; 
    public GroupId: number;
    //$GenericSet
    public static GetFullName (property?: keyof FieldModel ): string {
        if(!property) return "JIS.Models.FieldModel";
        return "JIS.Models.FieldModel." + <string>property;
    }

    public Clone (): ThisType<FieldModel> {
        return FieldModelHelper.CloneObject (this);
    }
}

export class FieldModelHelper {
    public static CloneObject (original: {[property in keyof FieldModel]?: FieldModel [property]}): FieldModel {
        var clone = new FieldModel ();
        this.Apply(original, clone);
        return clone;
    }

    public static Apply (original: {[property in keyof FieldModel]?: FieldModel [property]}, clone: FieldModel) {
        clone.set('Value', original.Value);
        clone.set('Label', original.Label);
        clone.set('Group', original.Group);
        clone.set('GroupId', original.GroupId);
    }
}
